import { TaxonomyFieldName } from 'v2/core/entities/fields';
import { Label } from 'v2/core/entities/labels';
import { UUID } from 'v2/core/entities/uuid';

export interface Taxonomy {
  id: UUID;
  name: string;
  hierarchy?: TaxonomyHierarchy;
}

export enum TaxonomyNodeType {
  Level = 'LEVEL',
  Label = 'LABEL',
}

export enum LabelType {
  Aspect = 'ASPECT',
  Cluster = 'CLUSTER',
  L1 = 'L1',
  Reason = 'REASON',
  Sentiment = 'SENTIMENT',
}

export interface TaxonomyNode {
  id: string;
  displayName?: string;
  description?: string;
  createdAt?: number;
  type?: LabelType;
  fieldName: TaxonomyFieldName;
  // UI related attributes -> necessary for visualizing taxonomy tree
  children?: TaxonomyNode[];
  subTreeLabels?: string[];
  subTreeLabelSet?: string[];
  value: string;
  expanded?: boolean;
  label?: string;
  isVisible?: boolean;
}

export interface TaxonomyEdge {
  sourceID: string;
  sourceType: TaxonomyNodeType;
  destinationID: string;
  destinationType: TaxonomyNodeType;
}

export interface TaxonomyHierarchy {
  root: string;
  version: number;
  edges?: TaxonomyEdge[];
  nodes?: TaxonomyNode[];
}

export interface ExcludedLabels {
  entities: TaxonomyNode[];
  reasons: Label[];
}
